import { getCurrentInstance, computed } from "vue";

export const useStore = () => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error("must be called in setup");
  const store  = computed(() => vm.proxy.$store);
  return store.value;
};
